import React, { useEffect, useState } from "react";
import ShelterEntry from "./ShelterEntry/ShelterEntry";
import classes from "./ShelterListPage.module.css";
import Grid from "@mui/material/Grid";
import { getShelters } from "../../../api/firestoreData";
import LoaderScreen from "../../common/LoaderScreen/LoaderScreen";
import BackButton from "../../common/BackButton";

function ShelterListPage() {
  const [shelters, setShelters] = useState(null);
  useEffect(() => {
    getShelters().then((res) => setShelters(res));
  }, []);

  if (!shelters) {
    return <LoaderScreen />;
  }
  return (
    <>
      <BackButton />
      <Grid
        container
        direction={"column"}
        justifyContent={"space-evenly"}
        alignItems={"center"}
        className={classes.grid}
        spacing={3}
      >
        {shelters.map((shelter) => (
          <Grid item className={classes.gridItem} key={shelter.id}>
            <ShelterEntry
              id={shelter.id}
              photo={shelter.images[0]}
              name={shelter.name}
              street={shelter.street}
              openingHours={shelter.openingHours}
              capacity={shelter.capacity}
              usedCapacity={shelter.usedCapacity}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default ShelterListPage;
